declare global {
  interface Window {
    __env: Record<string, string | undefined>;
  }
}

interface EnvironmentVariablesConfig {
  API_URL?: string;
  HOTKEYS_FORM_LIMIT: number;
  HOT_JAR_SITE_ID: number | undefined;
  HOTJAR_VERSION: number | undefined;
  MIXPANEL_TOKEN: string | undefined | null;
  MIXPANEL_DOMAIN: string | undefined | null;
  MIXPANEL_COOKIE_DOMAIN: string | undefined | null;
  SOCIAL_PROVIDERS: string[] | undefined;
  BUILD_CREATED_AT: string | undefined;
}

const config: EnvironmentVariablesConfig = {
  API_URL: process.env.EXPO_PUBLIC_API_URL ?? window.__env.EXPO_PUBLIC_API_URL,
  HOTKEYS_FORM_LIMIT: 6,
  HOT_JAR_SITE_ID: isNaN(Number(window.__env.HOT_JAR_SITE_ID))
    ? undefined
    : Number(window.__env.HOT_JAR_SITE_ID),
  HOTJAR_VERSION: isNaN(Number(window.__env.HOTJAR_VERSION))
    ? undefined
    : Number(window.__env.HOT_JAR_VERSION),

  MIXPANEL_TOKEN: window.__env.MIXPANEL_TOKEN,
  MIXPANEL_DOMAIN: window.__env.MIXPANEL_DOMAIN,
  MIXPANEL_COOKIE_DOMAIN: window.__env.MIXPANEL_COOKIE_DOMAIN,
  SOCIAL_PROVIDERS: window.__env.SOCIAL_PROVIDERS?.split(",") ?? [
    "google",
    "facebook",
  ],
  BUILD_CREATED_AT: window.__env.BUILD_CREATED_AT,
};

export default config;
